import { put, take } from "typed-redux-saga";
import workerChannel from "./worker.channel";
import { TTau } from "../../types";
import { workerActions } from "../../reducers/worker.slice";

function* tauWorkerSaga() {
  const webWorker = new Worker(
    new URL("../workers/tau.worker.js", import.meta.url)
  );
  const channel = workerChannel(webWorker);

  while (true) {
    try {
      const action = yield* take(workerActions.calculateTau);
      webWorker.postMessage({
        X: action.payload.X,
        Y: action.payload.Y,
        Z: action.payload.Z,
        V: action.payload.V,
      });

      const data = (yield* take(channel)) as TTau;

      yield* put(
        workerActions.setTau({
          key: action.payload.key,
          tau: data,
        })
      );
    } catch (e) {
      console.error(e);
    }
  }
}

export default tauWorkerSaga;
